'use client';

import dynamic from 'next/dynamic';

// Client component wrapper for AuthGuard to allow ssr: false
// This is needed because ssr: false cannot be used in Server Components
const AuthGuardClient = dynamic(
  () => import('@ias/components/src/components/AuthGuard').then((mod) => mod.AuthGuard),
  {
    ssr: false
  }
);

type AuthGuardWrapperProps = {
  params: any;
  requiredRoles?: string[];
};

export function AuthGuardWrapper({ params, requiredRoles }: AuthGuardWrapperProps) {
  return <AuthGuardClient params={params} requiredRoles={requiredRoles} />;
}

